export default class {
	idDocumentoAta
	filtros
	constructor(documentoAnexo) {
		this.idDocumentoAta = documentoAnexo.id
		this.filtros = new Object({ tipoRegistroDocumento: documentoAnexo.tipoRegistroDocumento })
	}
}
